import { t } from "@lingui/macro";

import { CrownIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

export const NotificationExample = () => {
  return (
    <VStack alignItems={"center"} position={"relative"} mb={12}>
      <Box
        bg="surface-primary"
        width={254}
        height={8}
        borderTopLeftRadius={"4"}
        borderTopRightRadius={"4"}
        opacity={0.3}
      />
      <Box
        bg="surface-primary"
        width={302}
        height={12}
        borderTopLeftRadius={"4"}
        borderTopRightRadius={"4"}
        opacity={0.5}
      />
      <Box
        position={"absolute"}
        bottom={0}
        width={302}
        height={32}
        style={{
          shadowColor: "#103D2C",
          shadowOffset: { width: 0, height: 20 },
          shadowOpacity: 0.4,
          shadowRadius: 40,
        }}
      />
      <Box
        bg="surface-primary"
        width={340}
        height={140}
        borderRadius={"4"}
        p={4}
      >
        <HStack justifyContent="space-between" mb={4}>
          <HStack gap={2}>
            <CrownIcon />
            <Text variant="mainTiny">{t`WHOOSH`}</Text>
          </HStack>
          <Text variant="mainTiny" color="text-secondary">
            {t`Just Now`}
          </Text>
        </HStack>

        <Text
          testID="notification-nudge-modal-title"
          variant="mainBaseSemiBold"
          mb={2}
        >{t`Your booking has been confirmed!`}</Text>
        <Text
          variant="mainSmallMedium"
          color="text-primary"
        >{t`Your booking has been successfully confirmed. Thank you for choosing us!`}</Text>
      </Box>
    </VStack>
  );
};
